var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 44,
    viewBox: "0 0 43 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_206_5692)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3335 14.9998C18.3335 13.435 19.602 12.1665 21.1668 12.1665C22.7316 12.1665 24.0001 13.435 24.0001 14.9998C24.0001 16.5646 22.7316 17.8332 21.1668 17.8332C19.602 17.8332 18.3335 16.5646 18.3335 14.9998ZM21.1668 13.1665C20.1543 13.1665 19.3335 13.9873 19.3335 14.9998C19.3335 16.0124 20.1543 16.8332 21.1668 16.8332C22.1793 16.8332 23.0001 16.0124 23.0001 14.9998C23.0001 13.9873 22.1793 13.1665 21.1668 13.1665Z",
    fill: "#3D3B3A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5001 19.8332C17.6717 19.8332 17.0001 20.5047 17.0001 21.3332V22.1254C17.0001 22.1374 17.0089 22.1477 17.0208 22.1496C19.7666 22.5979 22.567 22.5979 25.3128 22.1496C25.3247 22.1477 25.3335 22.1374 25.3335 22.1254V21.3332C25.3335 20.5047 24.6619 19.8332 23.8335 19.8332H23.6062C23.5886 19.8332 23.5712 19.8359 23.5545 19.8414L22.9775 20.0298C21.8009 20.414 20.5327 20.414 19.3561 20.0298L18.7791 19.8414C18.7624 19.8359 18.7449 19.8332 18.7274 19.8332H18.5001ZM16.0001 21.3332C16.0001 19.9525 17.1194 18.8332 18.5001 18.8332H18.7274C18.8504 18.8332 18.9726 18.8526 19.0895 18.8908L19.6665 19.0792C20.6414 19.3975 21.6922 19.3975 22.6671 19.0792L23.2441 18.8908C23.361 18.8526 23.4832 18.8332 23.6062 18.8332H23.8335C25.2142 18.8332 26.3335 19.9525 26.3335 21.3332V22.1254C26.3335 22.6275 25.9695 23.0557 25.4739 23.1366C22.6214 23.6023 19.7122 23.6023 16.8596 23.1366C16.364 23.0557 16.0001 22.6275 16.0001 22.1254V21.3332Z",
    fill: "#3D3B3A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_206_5692",
    x: 0.00012207,
    y: 0.166504,
    width: 42.3334,
    height: 43.3193,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.8675 0 0 0 0 0.652401 0 0 0 0 0.297842 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_206_5692"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_206_5692",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/UserIcon.704f3d2e63abc2a4cf2a387f7631b1b1.svg";
export { ForwardRef as ReactComponent };